import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import AuthAxios from "../../config/authAxios"
import apiRoutes from "../apiConfigs"

export const teachingVideoEditApi = createAsyncThunk(
    'auth/teachingVideos/edit',
    async (data, { rejectWithValue }) => {
        try {
            const response = await AuthAxios.patch(apiRoutes.teachingVideosAction(`${data.id}`, 1), data,


            )
            return response?.data
        } catch (error) {
            return rejectWithValue(error?.response?.data)
        }
    }
)

const teachingVideoEditSlice = createSlice({
    name: 'teachingVideo Edit',
    initialState: { result: [], loading: false, error: null, message: "" },
    extraReducers: (builder) => {
        builder.addCase(teachingVideoEditApi.pending, (state, action) => {
            state.loading = true
        })
        builder.addCase(teachingVideoEditApi.fulfilled, (state, action) => {
            state.loading = false
            state.result = action?.payload?.result
            state.message = action?.payload?.message
        })
        builder.addCase(teachingVideoEditApi.rejected, (state, action) => {
            state.loading = false
            state.error = action?.payload?.error
            state.message = action?.payload?.message
        })
    },
})

export const teachingVideoEditReducer = teachingVideoEditSlice.reducer